import { render, staticRenderFns } from "./Div.vue?vue&type=template&id=d6ddff6e&"
import script from "./Div.vue?vue&type=script&lang=js&"
export * from "./Div.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports